import React from 'react';

// components
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import { default as BlockchainTransferForm } from '../../modules/Transfers/BlockchainTransfer';

const BlockchainTransfer = () => {
  return (
    <PageContentCard>
      <BlockchainTransferForm />
    </PageContentCard>
  );
};

export default BlockchainTransfer;
